function SomeFn() {}

SomeFn._r = [2];
SomeFn.displayName = "SomeFn";

var SomeClass = function SomeClass() {};

SomeClass.displayName = "SomeClass";